import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { IncidenciaUsuarioCategoriaService, MenuFuncionService } from '../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, IncidenciaUsuarioCategoria, SearchIncidenciaUsuarioCategoriaRequest } from '../../../../src/app/shared/model';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-incidenciaUsuarioCategoriaLista',
  templateUrl: './incidenciaUsuarioCategoriaLista.component.html',
  styles: [
  ]
})

export class IncidenciaUsuarioCategoriaListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isTipoSearching: boolean = false;
  canEdit: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  verSoloActivos: boolean = true;
  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;
  isCategoriaSearching: boolean;
  incidenciaCategoriaList: IncidenciaUsuarioCategoria[];
  filteredCategoriaList: IncidenciaUsuarioCategoria[];

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private service: IncidenciaUsuarioCategoriaService,
    private datePipe: DatePipe) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.INCIDENCIA_USUARIO_CATEGORIA).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result){
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_CATEGORIA_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.INCIDENCIA_USUARIO_CATEGORIA_LIST);
          if (this.canView){
            this.loadView();
          } else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.router.navigate(['/']);
          }
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.getCategorias();
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };

    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'Codigo': [null],
      'Nombre': [null],
      'CategoriaPadreId': [null],
    });
  }

  getCategorias(){
    let r = new SearchIncidenciaUsuarioCategoriaRequest(null,null,null,null,null,null,null,null);
    this.isCategoriaSearching = true;
    this.service.search(r).subscribe((data)=>{
      if (data != null) {
        this.incidenciaCategoriaList = data.result;
        this.filteredCategoriaList = this.incidenciaCategoriaList;
        this.isCategoriaSearching = false;
      }
    },
    (err: HttpErrorResponse) =>{
      this.isCategoriaSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  displayCategoria(categoria: IncidenciaUsuarioCategoria): string {
    return categoria?.Nombre ? categoria.Nombre + " | " + categoria.Codigo : 'Todas';
  }

  filterCategoriaList(value){
    const filterValue = value.toLowerCase();
    this.filteredCategoriaList = this.incidenciaCategoriaList.filter(x =>
      x.Nombre?.toLowerCase().includes(filterValue) ||
      x.Codigo?.toLowerCase().includes(filterValue));
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Codigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Codigo;
    else
      this.query.addParams("Codigo",this.searchForm.value.Tipo);

    index = this.query.params.findIndex(obj => obj.key === "Nombre");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Nombre;
    else
      this.query.addParams("Nombre",this.searchForm.value.Nombre);

    index = this.query.params.findIndex(obj => obj.key === "CategoriaPadreId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.CategoriaPadreId?.Id;
    else
      this.query.addParams("CategoriaPadreId",this.searchForm.value.CategoriaPadreId?.Id);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.verSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos",this.verSoloActivos.toString());
  }

  add() {
    if(this.canAdd){
      this.router.navigate(['incidencia-usuario-categoria-edit', 0]);
    }else{
      this.sharedFunctions.showMessage("No tiene permisos para crear una nueva incidencia", "Error");
    }
  }

  edit(item: IncidenciaUsuarioCategoria) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['incidencia-usuario-categoria-edit', item.Id]);
  }

  onExport() {
    var search = new SearchIncidenciaUsuarioCategoriaRequest(null, null, null, "", null, null, this.verSoloActivos, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "IncidenciasUsuarioCategorias_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
